export enum NoteMenuItemType {
    DELETE,
}

export interface NoteMenuItem {
    type: NoteMenuItemType;
    label: string;
    icon: string;
}
